import {Component} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {WorkflowStep} from "../workflow-step";
import {WorkflowService} from "../workflow.service";
import {DeviceRelocationWorkflowService} from "./device-relocation-workflow.service";
import {DialogService} from "../../bootstrap-modal/dialog.service";
import {SetupRelocationDialogComponent} from "./setup-relocation-dialog.component";
import {handleErrors} from "../../misc/handle-errors.decorator";
import {RelocateAssetBundleModel} from "./relocate-asset-bundle.model";
import {toggleLoading} from "../../misc/loading.decorator";

@Component({
  templateUrl: "./device-relocation-overview.template.pug",
  providers: [
    DeviceRelocationWorkflowService,
    DialogService,
  ],
})

export class DeviceRelocationOverview extends WorkflowStep {
  deviceRelocationId: string;
  error: Error;
  assets: RelocateAssetBundleModel[] = [];
  disableStep: boolean;

  deploymentId: string;

  constructor(
    public route: ActivatedRoute,
    public router: Router,
    public workflowService: WorkflowService,
    private deviceRelocationWorkflowService: DeviceRelocationWorkflowService,
    public dialogService: DialogService,
  ) {
    super();
    this.saveOnContinue = true;
  }

  @toggleLoading()
  @handleErrors()
  async ready(): Promise<void> {
    this.deviceRelocationId = this.workflowService.workflowConfig.targetId;
    const result = await this.deviceRelocationWorkflowService.getRelocationAssets(this.deviceRelocationId);
    this.assets = result.assets;
    this.deploymentId = result.deploymentId;
    this.disableStep = result.closed;
  }

  @handleErrors()
  async autoSave(): Promise<boolean | string> {
    if (this.disableStep || this.deploymentId) {
      return this.deploymentId ? `deployment?id=${this.deploymentId}` : true;
    }

    const result = await SetupRelocationDialogComponent.showCreateDialog(
      this.dialogService,
      {
        deviceRelocationId: this.deviceRelocationId,
        relocationDeploymentName: `${this.workflowService.readableTargetName} Deployment`,
      },
    );

    if (!result) return false;

    this.deploymentId = result.deploymentId;
    this.disableStep = true;

    return `deployment?id=${result.deploymentId}`;
  }
}
